// Single source of truth for brand color literals used inside JS / sx
// (CSS-only consumers should reference the matching `var(--an-*)` instead).
// Keep these in sync with App.css and the Accessory Navigator design system.

export const brandColors = {
    green50: "#F2FBF8",
    green100: "#D3F4E8",
    green200: "#48BD9C",
    green300: "#0ACBAA",
    green400: "#2CA082",
    green500: "#1C5346",
    green600: "#1C453D",
    green700: "#027A48",
    yellow: "#FDCD43",
    yellowHover: "#EEC03A",
    rose50: "#F3DDE3",
    rose500: "#BD4769",
    ink: "#0E1529",
    ink2: "#181D27",
    text: "#0A0D12",
    muted1: "#414651",
    muted2: "#535862",
    muted3: "#717680",
    muted4: "#A4A7AE",
    panel: "#F5F5F5",
    border: "#E9EAEB",
    border2: "#D5D7DA",
    danger: "#D32F2F",
    dangerHover: "#B71C1C",
} as const;

export type BrandColor = keyof typeof brandColors;
